import { useMemo } from "react";
import { Trigger } from "../../entities/trigger";
import { useGetTriggerQuery, useGetTriggersQuery } from "./triggerEndpoints";

/**
 * @param triggerID
 * @param opt
 * @param opt.skip
 */
export function useTrigger(
  triggerID: number | undefined | null,
  opt?: { skip?: boolean }
) {
  const triggerQuery = useGetTriggerQuery(triggerID ?? 0, {
    skip: !triggerID || opt?.skip,
  });
  const triggerEntity = triggerQuery.data;

  return useMemo(() => {
    const ret: typeof triggerQuery & {
      trigger?: Trigger | undefined;
    } = {
      ...triggerQuery,
    };
    if (triggerEntity) ret.trigger = new Trigger(triggerEntity);
    return ret;
  }, [triggerQuery, triggerEntity]);
}

/**
 *
 */
export function useTriggers() {
  const triggerQuery = useGetTriggersQuery();
  const triggerEntitiesMap = triggerQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof triggerQuery & {
      triggers?: Trigger[];
      triggersMap?: { [id: number]: Trigger };
    } = {
      ...triggerQuery,
      triggers: [],
      triggersMap: {},
    };
    if (triggerEntitiesMap) {
      const triggers: Trigger[] = [];
      const triggersMap: { [id: number]: Trigger } = {};

      for (const key in triggerEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(triggerEntitiesMap, key)) {
          const c = triggerEntitiesMap[key];
          if (c) {
            const trigger = new Trigger(c);
            triggers.push(trigger);
            if (trigger?.id) triggersMap[trigger.id] = trigger;
          }
        }
      }
      ret.triggers = triggers;
      ret.triggersMap = triggersMap;
    }

    return ret;
  }, [triggerQuery, triggerEntitiesMap]);
}
